/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Statuses_In_ReviewInputs */

const es_feedback_statuses_in_review = /** @type {(inputs: Feedback_Statuses_In_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En revisión`)
};

const en_feedback_statuses_in_review = /** @type {(inputs: Feedback_Statuses_In_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Review`)
};

/**
* | output |
* | --- |
* | "In Review" |
*
* @param {Feedback_Statuses_In_ReviewInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_statuses_in_review = /** @type {((inputs?: Feedback_Statuses_In_ReviewInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Statuses_In_ReviewInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_statuses_in_review(inputs)
	return en_feedback_statuses_in_review(inputs)
});
export { feedback_statuses_in_review as "feedback.statuses.in_review" }